// extracted by mini-css-extract-plugin
export var desken = "sticky-nav-module--desken--764a8";
export var desktopNav = "sticky-nav-module--desktop-nav--f558b";
export var headerCta = "sticky-nav-module--header-cta--f1817";
export var logo = "sticky-nav-module--logo--ea619";
export var menuIcon = "sticky-nav-module--menu-icon--66b41";
export var mkbsdMenu = "sticky-nav-module--mkbsd-menu--d9132";
export var mkbsdMenuName = "sticky-nav-module--mkbsd-menu-name--be384";
export var mobileNav = "sticky-nav-module--mobile-nav--70413";
export var quickNav = "sticky-nav-module--quick-nav--91a43";
export var quickNavItem = "sticky-nav-module--quick-nav-item--b5eda";
export var quickNavItemLabel = "sticky-nav-module--quick-nav-item-label--22485";
export var quickNavLink = "sticky-nav-module--quick-nav-link--c0291";
export var quickNavLinkActive = "sticky-nav-module--quick-nav-link-active--a06bd";
export var searchBox = "sticky-nav-module--search-box--6da92";
export var searchContainer = "sticky-nav-module--search-container--4bc6d";
export var searchIcon = "sticky-nav-module--search-icon--f8431";
export var stickyNav = "sticky-nav-module--sticky-nav--e4b77";
export var topnav = "sticky-nav-module--topnav--211da";
export var wrapper = "sticky-nav-module--wrapper--0d1ee";